import React, { useState } from "react";
import InputMask from "react-input-mask";


export default function PopupForm({ open, onClose, onSubmit }) {
    const [formData, setFormData] = useState({
        nome: "",
        telefone: "",
    });

    const [mensagem, setMensagem] = useState("");
    const [enviando, setEnviando] = useState(false);

    if (!open) return null; // Não renderiza se estiver fechado

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.nome || !formData.telefone) {
            setMensagem("Preencha todos os campos.");
            return;
        }

        setEnviando(true);
        setMensagem("");

        try {
            await onSubmit(formData); // Vai chamar a função de envio (Firebase)
            setMensagem("Mensagem enviada com sucesso!");
            setFormData({ nome: "", telefone: "" });
        } catch (error) {
            setMensagem("Erro ao enviar. Tente novamente.");
        }

        setEnviando(false);
    };

    return (
        <div className="popup-overlay">
            <div className="popup-content">
                <button type="button" className="popup-close" onClick={onClose}>X</button>
                <h2>Entre em Contato!</h2>

                <form onSubmit={handleSubmit}>
                    <label>Nome *</label>
                    <input
                        type="text"
                        name="nome"
                        value={formData.nome}
                        onChange={handleChange}
                    />

                    <label>Telefone *</label>
                    <InputMask
                        mask="(99) 99999-9999"   // Formato brasileiro de celular
                        value={formData.telefone}
                        onChange={handleChange}
                    >
                        {(inputProps) => (
                            <input
                                {...inputProps}
                                type="text"
                                name="telefone"
                                placeholder="(99) 99999-9999"
                            />
                        )}
                    </InputMask>

                    <button type="submit" disabled={enviando}>
                        {enviando ? "Enviando..." : "Enviar"}
                    </button>
                </form>

                {mensagem && <p className="popup-message">{mensagem}</p>}
            </div>
        </div>
    );
}
